<template>
  
  <!-- Cookie Consent Panel -->
  <div class="pa-0 d-flex flex-wrap align-center justify-md-space-between justify-center ga-4">
    
    <!-- Panel Content (HIDDEN when popup is open) -->
    <div v-if="!showCookiePopup">
      <!-- Title and Text section -->
      <div class="d-flex flex-column align-md-center align-center text-md-center text-center w-md-100 w-100">
        <p class="w-md-80 w-80 px-1">We use cookies to enhance your browsing experience, serve personalised content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
          <a class="cookies_link" href="doc.php?doc=cookies.htm" target="_blank">Cookie Policy</a>
        </p>
      </div>
      
      <!-- Buttons section -->
      <div class="d-flex flex-md-row flex-column-reverse flex-wrap justify-md-center justify-center ga-2 w-100">
        <Button
        class=""
        :slim="true"
        version="action"
        label="Customise"
        @click="showCookiePopup = true"
        />
        
        <Button
        class=""
        :slim="true"
        version="primary"
        label="Accept All"
        @click="acceptAll"
        />
      </div>
    </div>

    <!-- Cookie Consent Popup (VISIBLE when "Customise" is clicked) -->
    <transition name="fade">
      <CookieConsentPopup v-if="showCookiePopup" />
    </transition>
    
  </div>
  
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useModalStore } from '@/store/modalStore';
import { useBottomSheetStore } from '@/store/bottomSheetStore';
import { acceptAllConsent } from '@/services/consent/cookieConsentService';

import Button from '../ComponentLibrary/Button.vue';
import CookieConsentPopup from './CookieConsentPopup.vue';

// Stores
const modalStore = useModalStore();
const bottomSheetStore = useBottomSheetStore();

// Controls popup visibility
const showCookiePopup = ref(false);

// Handle "Accept All"
const acceptAll = () => {
  acceptAllConsent();

  // Close modal (desktop)
  modalStore.closeModal();

  // Close bottom sheet (mobile)
  bottomSheetStore.closeSheet();

  // Reset local state
  showCookiePopup.value = false;
};
</script>

<style lang="scss">

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.cookies_link {
  color: $secondary;
}
</style>